<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                    <h6 class="mb-0">
                        {{ $t("Configure integrations with other platforms to streamline data sharing.") }}
                    </h6>
                </CCol>

                <CCol class="d-flex justify-content-end">
                    <ButtonCreate
                        @click="
                            $router.push({
                                name: 'add_integration',
                            })
                        "
                    >
                        {{ $t("Create integration") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.integrations.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="
                                            tables.integrations.allFields
                                        "
                                        :activeFields.sync="
                                            tables.integrations.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.integrations.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.integrations.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :items-per-page="tables.integrations.rows"
                                    :itemsPerPageSelect="{
                                        values: [5, 10, 20],
                                    }"
                                    :columnFilterValue.sync="
                                        tables.integrations.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :loading="tables.integrations.loading"
                                    striped
                                    hover
                                    v-bind="tables.integrations"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.integrations
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'integration_details',
                                                                params: {
                                                                    uuid: tables
                                                                        .integrations
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                "Details"
                                                            )
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'edit_integration',
                                                                query: {
                                                                    uuid: tables
                                                                        .integrations
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                "edit_integration"
                                                            )
                                                        }}
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #no-items-view>
                                        <div class="block-no-items section">
                                            <h2
                                                class="section__title text-no-items"
                                            >
                                                {{
                                                    $t(
                                                        "add_the_fields_to_import"
                                                    )
                                                }}
                                            </h2>
                                            <CButton
                                                color="success"
                                                class="button m-2 shadow"
                                                @click="
                                                    $router.push({
                                                        name: 'api_add',
                                                    })
                                                "
                                            >
                                                <span class="button__icon">
                                                    <CIcon
                                                        :content="
                                                            $options.icons
                                                                .cilPlus
                                                        "
                                                    />
                                                </span>
                                                <span class="button__text">
                                                    {{ $t("add_integration") }}
                                                </span>
                                            </CButton>
                                        </div>
                                    </template>
                                    <template #_selected="{ item }">
                                        <td class="py-2">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.integrations
                                                        .itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'integrations',
                                                        item
                                                    )
                                                "
                                            />
                                        </td>
                                    </template>
                                    <template #name="{ item }">
                                        <td class="py-2">
                                            <span class="mr-2">
                                                {{ item.name }}
                                            </span>
                                            <CBadge
                                                color="warning"
                                                class="text-white"
                                                v-c-tooltip="
                                                    $t('You need to login') +
                                                    '.'
                                                "
                                                v-if="
                                                    pluginRequireLogin(item) &&
                                                    item.temporary_credentials == ''
                                                "
                                            >
                                                <span>
                                                    {{ $t("¡warning!") }}
                                                </span>
                                            </CBadge>
                                        </td>
                                    </template>
                                    <template #pluginImage="{ item }">
                                        <td>
                                            <h6 class="font-weight-bold">
                                                {{ getPluginName(item) }}
                                            </h6>
                                            <!-- <CImg :src="getPluginImage(item)" class="plataform__img" /> -->
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/connector.api/getPluginsCredentials"
                                                :table="tables.integrations"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.integrations.total_pages > 0"
                            >
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.integrations.page"
                                    :pages="tables.integrations.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilReload,
    cilPencil,
    cilChart,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";
import { mapGetters } from "vuex";
export default {
    name: "ApisPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        TableSettings,
        ButtonCreate,
        ButtonExport,
        FilterFields,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilReload,
        cilChart,
    },
    data() {
        return {
            tables: {
                integrations: {
                    fields: [
                        {
                            key: "_selected",
                            label: "#",
                            sortable: false,
                            filter: false,
                            _filter: false,
                            fixed: true,
                            _style: "width:5%",
                        },
                        {
                            key: "id",
                            label: "id",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            fixed: true,
                            _style: "width:15%",
                        },
                        {
                            key: "name",
                            label: "name",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            _style: "width:40%",
                        },
                        {
                            key: "pluginImage",
                            label: "platform",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            _style: "width:40%",
                            _import: false,
                        },
                    ],
                    items: [],
                    order: "desc",
                    rows: 5,
                    page: 1,
                    total_pages: 0,
                    loading: true,
                    pagination: false,
                    sorter: true,
                    responsive: true,
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    itemSelected: null,
                    allFields: [],
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            storePlugins: "global/plugins",
        }),
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.integrations.rows = newValue;
            this.updatePagination(this.tables.integrations.page);
        },
        updatePagination(newValue) {
            this.tables.integrations.page = newValue;
            this.updateData();
        },
        async updatePagination(newValue) {
            this.tables.integrations.page = newValue;
            await this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "integrations",
                url: "/connector.api/getPluginsCredentials",
            });
            this.tables.integrations.itemSelected = null;
            this.tables.integrations.loading = false;
            this.updatePageLoading(false);
        },

        getPlugin(uuid) {
            return this.storePlugins.find((item) => {
                return item.uuid == uuid;
            });
        },
        getPluginName(uuid) {
            let plugin = this.getPlugin(uuid.driver_id);
            if (plugin) {
                return plugin.name;
            } else {
                return "";
            }
        },
        pluginRequireLogin(uuid) {
            let plugin = this.getPlugin(uuid.driver_id);
            if (plugin) {
                return plugin.temporary_credentials_required;
            } else {
                return false;
            }
        },
        getPluginImage(uuid) {
            let plugin = this.getPlugin(uuid);
            if (plugin) {
                return plugin.logo;
            } else {
                return "";
            }
        },

        async loadPlugins() {
            let plugins = await this.fetcher({
                url: "/connector.api/plugins",
            });

            this.$store.dispatch("global/savePlugins", {
                plugins: plugins._items,
            });
        },
    },
    async mounted() {
        await this.loadPlugins();
        await this.updateData();
    },
};
</script>

<style scoped lang="scss">
.plataform__img {
    height: 5em !important;
    width: auto;
}
</style>
